<div>
    <mat-icon (click)="toggleLockedStatus()" class="unlocked" *ngIf="!fieldLockService.isLocked(fieldName)" [matTooltip]="unlockedToolTip">sync</mat-icon>
    <mat-icon (click)="toggleLockedStatus()" class="locked" *ngIf="fieldLockService.isLocked(fieldName)" [matTooltip]="lockedToolTip">sync_lock</mat-icon>
</div>